<div class="flex flex-col">
  <mat-label class="flex flex-row items-center gap-2">
    {{ label | translate }}
    <span *ngIf="required && label">*</span>
    <app-icon
      *ngIf="infoTooltip"
      class="cursor-pointer"
      [matTooltip]="infoTooltip | translate"
      iconName="info"
      size="sm"
      fill="#1f5792"
      matTooltipPosition="above"></app-icon>
  </mat-label>
  <mat-form-field class="w-full" [ngClass]="{ 'mat-form-field-invalid': control?.invalid && control?.touched }">
    <mat-select
      [multiple]="multiple"
      [value]="value"
      [placeholder]="placeholder | translate"
      (selectionChange)="onSelectChange($event.value)"
      [disabled]="isDisabled"
      [panelClass]="panelClass">
      <div *ngIf="selectAll && multiple" class="flex flex-row items-center  border-b border-neutral-200">
        <div class="flex flex-row w-full items-center py-2 px-3 gap-1 cursor-pointer hover:bg-neutral-100" (click)="toggleSelectAll()">
          <app-icon [ngStyle]="{cursor:'pointer'}" size="md" [iconName]="isAllSelected ? 'close' : 'check'"></app-icon>
          <span class="ml-1">{{ (isAllSelected ? 'global.deselectAll' : 'global.selectAll') | translate }}</span>
        </div>
      </div>

      <mat-option *ngFor="let option of options" [value]="option.id ?? option.key">
        {{ option.name || option.value | translate }}
      </mat-option>
    </mat-select>
    <ng-container matSuffix>
      <ng-content select="[suffix]"></ng-content>
    </ng-container>
  </mat-form-field>

  <mat-error flowValidationErrors *ngIf="control?.invalid && control?.touched"></mat-error>
</div>
